import { Invite, InvitePage } from '@mkp/account-membership/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const inviteApiActions = createActionGroup({
  source: 'Invite Api',
  events: {
    'Delete Success': props<{ id: string; page: InvitePage }>(),
    'Delete Failure': props<{ status: number; id: string; page: InvitePage }>(),
    'Update Invite Success': emptyProps(),
    'Update Invite Failure': props<{ status: number }>(),
    'Delete Before Resend Success': props<{ invite: Invite; page: InvitePage }>(),
    'Delete Before Resend Not Found': props<{ invite: Invite; page: InvitePage }>(),
    'Delete Before Resend Failure': emptyProps(),
    'Resend Success': props<{ invite: Invite; page: InvitePage }>(),
    'Resend Failure': props<{ page: InvitePage }>(),
    'Redeem Invite Success': emptyProps(),
    'Redeem Invite Logged Out Success': emptyProps(),
    'Redeem Invite Failure': props<{ error: unknown }>(),
    'Redeem Invite For Non Existing User': props<{ token: string; email: string }>(),
    'Redeem Invite Email Mismatch': props<{
      actorEmail: string;
      invitedEmail: string;
    }>(),
    'Redeem Invite After User Creation Success': props<{ email: string }>(),
    'Redeem Invite After User Creation Failure': props<{ error: unknown }>(),
  },
});
